module.exports = __webpack_public_path__ + "static/img/ranking-user.dfc5f3c7.png";